export default "__VITE_ASSET__BjHfKyBH__"